import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryPreview() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              热门影视分类
            </h2>
            <p className="text-foreground-600 text-sm">
              电影、电视剧、综艺、动漫，你想看的全都有
            </p>
          </div>
          <Link
            to="/category"
            className="whitespace-nowrap text-primary-600 hover:text-primary-700 text-sm font-medium flex items-center gap-1 transition-colors duration-200"
          >
            查看全部分类
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to="/category"
              className="relative group rounded-xl overflow-hidden aspect-[3/4] cursor-pointer"
            >
              <img
                src={cat.items[0].image}
                alt={cat.name}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 w-full p-4">
                <div className="flex items-center gap-2 mb-1">
                  <i className={`${cat.icon} text-primary-400 text-lg`}></i>
                  <span className="text-white font-heading font-bold text-base">{cat.name}</span>
                </div>
                <span className="text-white/70 text-xs">{cat.items.length}部热门推荐</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}